<script lang="ts">
import { defineComponent, inject, reactive, computed } from 'vue'
import LayoutStoryCardsCols from '@/components/contents/LayoutStoryCardsCols.vue'
import stateInitializer from '@/models/stateInitializer'
import { storiesThemePath } from '@/generated/railsRoutes'

export default defineComponent({
  name: 'ThemeHero',

  components: {
    LayoutStoryCardsCols,
  },

  setup() {
    // constants
    const THEMES = inject<Record<string, string>>('THEMES') || {}
    const MAX_STORIES = 6 as const

    const IMAGE_OPTIONS = {
      width: {
        pc: 317,
        sp: 248,
      },
      height: {
        pc: 136,
        sp: 128,
      },
    } as const

    interface State {
      topStories: StoryItem[],
      themeId: number | undefined,
    }

    const state: State = reactive({
      topStories: [],
      themeId: undefined,
    })

    stateInitializer(state, 'hero')

    const themeLabel = computed(() => state.themeId ? THEMES[state.themeId.toString()] : '')

    return {
      // constants
      IMAGE_OPTIONS,
      MAX_STORIES,

      // routed
      storiesThemePath,

      // data
      state,

      // computed
      themeLabel,
    }
  },
})
</script>

<template>
  <section
    v-if="state.topStories.length"
    class="f-section__hero">
    <div class="f-section__hero--body">
      <h2 class="h2 u-text__xx-large u-text__bold">
        新着特集
      </h2>

      <LayoutStoryCardsCols
        :items="state.topStories"
        :cols="{ pc: 3, sp: 'fixed' }"
        :heading-options="{ maxLine: 2 }"
        :image-options="IMAGE_OPTIONS"
        has-items-total />

      <p
        v-if="state.themeId && state.topStories.length >= MAX_STORIES"
        class="p u-text__right u-margin__larger">
        <a
          class="a u-text__small u-action__forward"
          :href="storiesThemePath({ id: state.themeId })">
          {{ themeLabel }}の特集をもっと見る
        </a>
      </p>
    <!-- /.f-section__hero body --></div>
  <!-- /.f-section__hero --></section>
</template>

<style lang="sass" scoped>
// foundation
.f-section__hero
  $root: &
  position: relative

  & &--body
    width: 100%
    margin: 0 auto

  +breakpoint
    padding:
      left: #{$global-prop-sp}px
      right: #{$global-prop-sp}px

    // Hero の基本スタイル構造は TemplateDefault 側に共通的に持ってるので、
    // このページ用にボーダーを付与するために、TemplateDefault 側の基本構造を触るよりは、
    // こちらで疑似要素を使って擬似的なボーダーとする。
    &::before
      $hero-margin-bottom-em: 2.5
      $hero-margin-bottom-px: $font-normal-px * $hero-margin-bottom-em
      $border-weight: 8
      $border-position: -(math.div($hero-margin-bottom-px, 2)) - (math.div($border-weight, 2))
      content: ""
      width: 100%
      height: #{$border-weight}px
      display: block
      position: absolute
      bottom: changeSizePx2Em($border-position)
      left: 0
      background-color: $border-x-light-gray
</style>
